import React from "react";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Message from "../../components/message/message";

const ValidateProfile = () => {
    const {userLogged,  isFullProfile, token} = useSelector( state => state.userLogged);
    const navigate = useNavigate();

    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    return(
        <Message 
            title={t("validateProfile.title")}
            content={t("validateProfile.content")}
            open={!isFullProfile && userLogged?.role==='Artista' && window.location.pathname!=='/profile' && token !== null} 
            onClose={()=>navigate('/profile')}
        />
    )
}

export default ValidateProfile;